module.exports = __webpack_public_path__ + "static/media/Program1.b993a526.jpg";